export default __webpack_public_path__ + "static/Baraja_Divertida_Loteria-7d6cab4ae2965f2e25dacd88f0e2ee8e.png";